<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Accreditation Summary Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel :data="selected" :fields="export_fields" name="accreditationSummaryReport.xls" type="csv">
            <v-btn class="teal white--text" color="primary" dark depressed small>
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>

      <v-data-table v-model="selected"
                    :headers="headers" :items="accrSummaryReports.rows"
                    :loading="loading"
                    :options.sync="options"
                    :server-items-length="accrSummaryReports.count"
                    class="elevation-1"
                    item-key="id" loading-text="Loading... please wait" show-select>
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-text-field v-model="accreditorValue" label="Accreditor Name" type="text"></v-text-field>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-layout class="p-3" row wrap>
                <v-flex xs9>
                  <v-text-field v-model="courseValue" label="No. of Courses Accredited"
                                type="number"></v-text-field>
                </v-flex>
                <v-flex style="margin-top: 10px" xs3>
                  <v-select v-model="courseComparisonValue" :items="comparisons" class="comparisonSelect" dense
                            item-text="name" item-value="value" solo></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
              <v-layout class="p-3" row wrap>
                <v-flex xs9>
                  <v-text-field v-model="cpdProviderValue" label="No. of CPD Providers Accredited"
                                type="number"></v-text-field>
                </v-flex>
                <v-flex style="margin-top: 10px" xs3>
                  <v-select v-model="comparisonValue" :items="comparisons" class="comparisonSelect" dense
                            item-text="name" item-value="value" solo></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
        <template v-slot:[`item.accreditorName`]="{ item }">
          <label for="item">{{
              item.accreditorName ? item.accreditorName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.noCourseAccredated`]="{ item }">
          <label for="item">{{
              item.noCourseAccredated ? item.noCourseAccredated : "-"
            }}</label>
        </template>
        <template v-slot:[`item.noCpdProviderAccredated`]="{ item }">
          <label for="item">{{
              item.noCpdProviderAccredated ? item.noCpdProviderAccredated : "-"
            }}</label>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {AccreditationSummaryService} from "./accreditation-summary-service";

export default {
  data() {
    return {
      accrSummaryReports: [],
      headers: [
        {
          text: "Accreditor's Name", value: "accreditorName"
        },
        {
          text: "No. of Courses Accredited",
          value: "noCourseAccredated"
        },
        {
          text: "No. of CPD Providers Accredited",
          value: "noCpdProviderAccredated"
        },
      ],
      selected: [],
      export_fields: {
        "Accreditor's Name": "accreditorName",
        "No. of Courses Accredited": "noCourseAccredated",
        "No. of CPD Providers Accredited": "noCpdProviderAccredated",
      },
      courseValue: null,
      comparisons: [
        {name: "=", value: "eq"},
        {name: "<", value: "lt"},
        {name: ">", value: "gt"},
        {name: "<=", value: "lte"},
        {name: ">=", value: "gte"},
      ],
      courseComparisonValue: "eq",
      cpdProviderValue: null,
      comparisonValue: "eq",
      accreditorValue: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchAccrSummaryReports();
      },
      deep: true,
    },
    accreditorValue: function (val) {
      this.accreditorValue = val == '' ? null : val;
      this.fetchAccrSummaryReports();
    },
    courseValue: function (val) {
      this.courseValue = val;
      this.fetchAccrSummaryReports();
    },
    courseComparisonValue: function (val) {
      this.courseComparisonValue = val;
      this.fetchAccrSummaryReports();
    },
    cpdProviderValue: function (val) {
      this.cpdProviderValue = val;
      this.fetchAccrSummaryReports();
    },
    comparisonValue: function (val) {
      this.comparisonValue = val;
      this.fetchAccrSummaryReports();
    },
  },
  async beforeMount() {
    this.fetchAccrSummaryReports();
  },
  methods: {
    async fetchAccrSummaryReports() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.accreditorValue !== null && (searchParams += '&accreditorName=' + this.accreditorValue);
      this.courseValue !== null && (searchParams += `&noCourseAccredated=${this.courseValue}&courceSign=${this.courseComparisonValue}`);
      this.cpdProviderValue !== null && (searchParams += `&noCpdProviderAccredated=${this.cpdProviderValue}&cpdProviderSign=${this.comparisonValue}`);

      const res = await AccreditationSummaryService.getAccreditationSummaryWP(searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.accrSummaryReports = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching accreditation summary reports, Please try Again!"
        );
      }
    },
  },
};
</script>

<style scoped>
.comparisonSelect {
  font-weight: bold;
  font-size: medium;
}
</style>
